import { useState } from "react";
import logo1 from "../assets/bgy.png";
import logo2 from "../assets/pentaspace.png";
import logo3 from "../assets/caid.png";
import img1 from "../assets/bgy/image1.png";
import img2 from "../assets/bgy/image2.png";
import img3 from "../assets/bgy/image3.png";

import img4 from "../assets/pentaspace/image1.png";
import img5 from "../assets/pentaspace/image2.png";
import img6 from "../assets/pentaspace/image3.png";
import img7 from "../assets/pentaspace/image4.png";
import img8 from "../assets/pentaspace/image5.png";

import img9 from "../assets/caid/image1.png";
import img10 from "../assets/caid/image2.png";
import img11 from "../assets/caid/image3.png";
import img12 from "../assets/caid/image4.png";
import img13 from "../assets/caid/image5.png";

const COMPANY = "Arch Point Consultants";

const PARTNERS = [
  {
    id: "bgy",
    name: "Buckley Gray Yeoman",
    abbr: "BGY",
    tagline: "International Architectural Practice",
    origin: "London, UK",
    description:
      "Buckley Gray Yeoman is an internationally acclaimed architectural practice known for transforming opportunities into exceptional places. Their approach goes beyond fulfilling project briefs uncovering hidden potential and creating innovative design solutions that add lasting value.",
    description2:
      "With a strong commitment to client objectives, BGY delivers architecture that is thoughtful, responsible, and commercially effective, while creating spaces that inspire, engage, and enhance human experiences. Their work combines creativity with precision, balancing sensitivity and authenticity with a distinctive sense of character and innovation.",
    logo: logo1,
    // "light" = white card (for dark or coloured logos)
    // "dark"  = charcoal card (switch to this if a logo is white or very light)
    logoTone: "light",
    images: [img1, img2, img3],
    imageLabels: [
      "Urban Development",
      "Commercial Architecture",
      "Civic Spaces",
    ],
    stats: [
      { label: "Founded", value: "1994" },
      { label: "Projects", value: "500+" },
      { label: "Reach", value: "Global" },
      { label: "Awards", value: "50+" },
    ],
    expertise: [
      "Master Planning",
      "Commercial Architecture",
      "Workplace Design",
      "Residential",
      "Urban Regeneration",
    ],
  },
  {
    id: "pentaspace",
    name: "Pentaspace Design Studio",
    abbr: "Pentaspace",
    tagline: "Award-Winning Architecture & Interior Design",
    origin: "India · Est. 2007",
    description:
      "Pentaspace is an award-winning architecture and interior design firm renowned for creating distinctive, innovative, and timeless design solutions. Established in 2007, the firm has successfully delivered over 20 million sq. ft. of built space across diverse sectors in the Indian real estate market.",
    description2:
      "With a strong focus on design excellence, functionality, and sustainability, Pentaspace transforms ideas into impactful spaces that inspire and endure.",
    logo: logo2,
    logoTone: "light",
    images: [img4, img5, img6, img7, img8],
    // Add one label per image (falls back to "Featured project N" if missing)
    imageLabels: [
      "Residential Towers",
      "Commercial Interiors",
      "Mixed-Use Developments",
    ],
    stats: [
      { label: "Established", value: "2007" },
      { label: "Built Space", value: "20M+ sqft" },
      { label: "Presence", value: "Pan India" },
      { label: "Typologies", value: "Multi" },
    ],
    expertise: [
      "Architecture",
      "Interior Design",
      "Sustainable Design",
      "Space Planning",
      "Concept Development",
    ],
  },
  {
    id: "caid",
    name: "CAID",
    abbr: "CAID",
    tagline: "Architects + Interior Designers",
    origin: "India · 30+ Years",
    description:
      "With over 30 years of experience, CAID is led by Ar. Shubhanan Chitnis a visionary architect recognized for his creative approach, technical expertise, and commitment to design excellence. Having successfully designed numerous industrial projects across India, the firm seamlessly blends innovation, functionality, and timeless architectural principles.",
    description2:
      "CAID's portfolio reflects a deep understanding of industry requirements, delivering solutions that are both aesthetically refined and operationally effective creating efficient, sustainable, and impactful spaces.",
    logo: logo3,
    logoTone: "light",
    images: [img9, img10, img11, img12, img13],
    imageLabels: [
      "Industrial Facilities",
      "Corporate Campuses",
      "Landmark Projects",
    ],
    stats: [
      { label: "Experience", value: "30+ yrs" },
      { label: "Projects", value: "200+" },
      { label: "Presence", value: "National" },
      { label: "Director", value: "Ar. S. Chitnis" },
    ],
    expertise: [
      "Industrial Architecture",
      "Interior Design",
      "Sustainable Solutions",
      "Project Delivery",
      "Technical Design",
    ],
  },
];

/* ── tiny helpers ── */
function Placeholder({ label }) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-stone-100 border-2 border-dashed border-stone-200">
      <svg
        className="w-7 h-7 text-stone-300"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 15l-5-5L5 21"
        />
      </svg>
      {label && (
        <p className="text-xs text-stone-400 font-medium text-center px-3">
          {label}
        </p>
      )}
    </div>
  );
}

function Img({ src, alt, label }) {
  return src ? (
    <img src={src} alt={alt} className="w-full h-full object-cover" />
  ) : (
    <Placeholder label={label} />
  );
}

/**
 * Logo card: wide, padded, and on a solid background so transparent PNGs
 * stay readable. `tone` picks white or charcoal. If the image fails to load,
 * the partner's short name is shown instead.
 */
function LogoBox({ src, name, abbr, tone = "light" }) {
  const [failed, setFailed] = useState(false);
  const isDark = tone === "dark";

  return (
    <div
      className={`h-20 w-40 sm:h-24 sm:w-48 rounded-2xl border flex items-center justify-center flex-shrink-0 p-3 sm:p-4 ${
        isDark
          ? "bg-stone-900 border-stone-800"
          : "bg-white border-stone-200 shadow-sm"
      }`}
    >
      {src && !failed ? (
        <img
          src={src}
          alt={`${name} logo`}
          onError={() => setFailed(true)}
          className="max-w-full max-h-full object-contain"
        />
      ) : (
        <span
          className={`text-lg font-semibold tracking-tight ${
            isDark ? "text-white" : "text-stone-700"
          }`}
        >
          {abbr}
        </span>
      )}
    </div>
  );
}

/* ── detail panel ── */
function PartnerDetail({ partner }) {
  const [active, setActive] = useState(0);

  // One label per image, even if imageLabels has fewer entries
  const labels = partner.images.map(
    (_, i) => partner.imageLabels[i] ?? `Featured project ${i + 1}`
  );

  return (
    <div className="flex flex-col gap-5">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 items-start">
        {/* About + description + project images */}
        <div className="bg-white rounded-3xl border border-stone-200 p-6 sm:p-8 flex flex-col">
          {/* Identity */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5 mb-6 sm:mb-7">
            <LogoBox
              src={partner.logo}
              name={partner.name}
              abbr={partner.abbr}
              tone={partner.logoTone}
            />
            <div className="flex-1 min-w-0">
              <h2 className="text-[17px] font-semibold text-stone-900 leading-snug mb-1">
                {partner.name}
              </h2>
              <p className="text-[13px] text-stone-400 mb-2">
                {partner.tagline}
              </p>
              <span className="inline-block text-[11px] font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-1">
                {partner.origin}
              </span>
            </div>
          </div>

          <hr className="border-stone-100 mb-6" />

          {/* Description */}
          <p className="text-[13.5px] text-stone-600 leading-[1.85] mb-4">
            {partner.description}
          </p>
          <p className="text-[13.5px] text-stone-400 leading-[1.85]">
            {partner.description2}
          </p>

          {/* Project images, directly below the description */}
          <div className="mt-7 pt-6 border-t border-stone-100">
            <p className="text-[10px] font-semibold text-stone-400 uppercase tracking-[1px] mb-4">
              Featured projects
            </p>

            {/* Main image */}
            <div
              className="w-full rounded-2xl overflow-hidden mb-3 bg-stone-100"
              style={{ aspectRatio: "16/9" }}
            >
              <Img
                src={partner.images[active]}
                alt={labels[active]}
                label={labels[active]}
              />
            </div>

            {/* Thumbnails */}
            <div
              className="grid gap-2 sm:gap-3"
              style={{
                gridTemplateColumns: `repeat(${Math.min(
                  partner.images.length,
                  5
                )}, minmax(0, 1fr))`,
              }}
            >
              {partner.images.map((img, i) => (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  aria-label={labels[i]}
                  aria-pressed={active === i}
                  className={`rounded-lg sm:rounded-xl overflow-hidden cursor-pointer transition-all duration-150 ${
                    active === i
                      ? "ring-2 ring-amber-600 ring-offset-2"
                      : "ring-1 ring-stone-200 hover:ring-amber-400"
                  }`}
                  style={{ aspectRatio: "16/10" }}
                >
                  <Img src={img} alt={labels[i]} label={labels[i]} />
                </button>
              ))}
            </div>

            {/* Caption */}
            <p className="text-center text-[11.5px] text-stone-400 mt-4 tracking-wide">
              {labels[active]}
            </p>
          </div>
        </div>

        {/* Stats + Expertise (stays in view while the left card scrolls) */}
        <div className="flex flex-col gap-4 lg:sticky lg:top-28">
          {/* Stat grid */}
          <div className="grid grid-cols-2 gap-3">
            {partner.stats.map((s) => (
              <div
                key={s.label}
                className="bg-stone-50 border border-stone-200 rounded-2xl px-5 py-4"
              >
                <p className="text-[20px] sm:text-[22px] font-semibold text-amber-700 tracking-tight mb-1 break-words">
                  {s.value}
                </p>
                <p className="text-[10px] font-semibold text-stone-400 uppercase tracking-[0.9px]">
                  {s.label}
                </p>
              </div>
            ))}
          </div>

          {/* Expertise */}
          <div className="bg-white border border-stone-200 rounded-3xl px-6 py-5">
            <p className="text-[10px] font-semibold text-stone-400 uppercase tracking-[1px] mb-4">
              Areas of expertise
            </p>
            <div className="flex flex-wrap gap-2">
              {partner.expertise.map((e) => (
                <span
                  key={e}
                  className="text-[12.5px] text-stone-600 bg-stone-50 border border-stone-200 rounded-lg px-3 py-1.5"
                >
                  {e}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Partnership note */}
      <div className="bg-stone-900 rounded-3xl px-6 sm:px-7 py-5 flex items-start gap-4 border-l-2 border-amber-600">
        <svg
          className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
          />
        </svg>
        <p className="text-[13px] text-stone-400 leading-[1.75]">
          {COMPANY} partners with{" "}
          <span className="text-white font-medium">{partner.name}</span> to
          deliver integrated planning, development, and design solutions
          combining innovation, sustainability, and architectural excellence
          across every project.
        </p>
      </div>
    </div>
  );
}

/* ── page ── */
export default function CollaborationsPage() {
  const [activeId, setActiveId] = useState("bgy");
  const active = PARTNERS.find((p) => p.id === activeId);

  return (
    <div className="min-h-screen bg-stone-50">
      {/* Header */}
      <div className="bg-white border-b border-stone-200 pt-24 lg:pt-28">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
          <p className="text-[11px] font-semibold text-amber-700 uppercase tracking-[2px] mb-2">
            {COMPANY}
          </p>
          <h1 className="text-3xl font-semibold text-stone-900 tracking-tight mb-2">
            Collaborations
          </h1>
          <p className="text-[14px] text-stone-500 leading-relaxed max-w-lg">
            Strategic partnerships with world-class architecture and design
            firms shaping the built environment.
          </p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 pb-20">
        {/* Tab switcher */}
        <div className="flex gap-1.5 bg-white border border-stone-200 rounded-2xl p-1.5 mb-7 shadow-sm">
          {PARTNERS.map((p) => (
            <button
              key={p.id}
              onClick={() => setActiveId(p.id)}
              className={`flex-1 py-2.5 px-2 sm:px-4 rounded-xl text-[13px] sm:text-[13.5px] transition-all duration-150 cursor-pointer font-medium ${
                activeId === p.id
                  ? "bg-amber-600 text-white shadow-sm"
                  : "text-stone-400 hover:text-stone-700 hover:bg-stone-50"
              }`}
            >
              {p.abbr}
            </button>
          ))}
        </div>

        {/* Panel */}
        {active && <PartnerDetail key={activeId} partner={active} />}
      </div>
    </div>
  );
}